import React, { Fragment, useEffect, useState } from 'react'
import AddToTeam from './Add'
import ListTeams from './List'
import EmptyTeamCard from './_Components/EmptyTeamCard'

import { Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { usersService } from '../../../../../_services/users.service'
import { alertActions } from '../../../../../_actions/alert.actions'

export default function LocationTeam() {
  const dispatch = useDispatch(null)
  const [loading, setLoading] = useState(true)
  const [addToTeam, setAddToTeam] = useState(false)
  const [locationTeam, setLocationTeam] = useState(null)
  const [addingToTeam, setAddingToTeam] = useState(false)

  useEffect(() => {
    usersService.getLocationTeam()
    .then((team) => {
      setLocationTeam(team)
    })
    .catch(() => {
      dispatch(alertActions.error('Could not retrieve location team at this time. Please try again.'));
    })
    .then(() => {
      setLoading(false)
    })
  }, [dispatch])

  const handleAddToTeam = () => {
    setAddingToTeam(true)
    usersService.addToLocationTeam()
    .then((team) => {
      dispatch(alertActions.success('Added to location team.'));
      setAddToTeam(false)
    })
    .catch(() => {
      dispatch(alertActions.error('Could not add to location team at this time. Please try again.'));
    })
    .then(() => {
      setAddingToTeam(false)
    })
  }

  if (loading) {
    return <Spinner animation='border'/>
  }

  return (
    <Fragment>
      {addToTeam && <AddToTeam addingToTeam={addingToTeam} handleAddToTeam={handleAddToTeam} handleBack={() => setAddToTeam(false)}/>}
      {locationTeam && !addToTeam && <ListTeams locationTeam={locationTeam} handleShowAddToTeam={() => setAddToTeam(true)}/>}
      {!locationTeam && !addToTeam && <EmptyTeamCard handleShowAddToTeam={() => setAddToTeam(true)}/>}
    </Fragment>
  )
}
